<template>
  <div v-if="hasVisibleContent" data-test="meal-plan-progress" class="px-5 h-full w-full mt-2">
    <div class="py-2 max-w-xl mx-auto w-full">
      <div
        class="flex min-w-0 w-full px-6"
        :class="compact ? 'flex-col gap-3' : 'flex-col md:flex-row gap-3 md:gap-4 md:items-center'"
      >
        <div v-if="!compact" class="hidden md:block flex-shrink-0 text-sm text-gray-brand-700">
          <span class="font-semibold text-brand-600">{{ progressText }}</span>
        </div>

        <div class="flex-1 min-w-0 pr-4" :class="{ 'md:pr-6': !compact }">
          <div class="relative h-2.5 bg-gray-brand-200 overflow-hidden rounded-full">
            <div
              class="absolute inset-y-0 left-0 rounded-full bg-brand-500 transition-all duration-1000 ease-out"
              :style="{ width: fillWidth }"
            />
          </div>
        </div>
      </div>

      <div class="text-sm text-gray-brand-700 px-6 mt-3" :class="compact ? 'text-left' : 'text-center md:hidden'">
        <span class="font-semibold text-brand-600">{{ progressText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import mapRelationship from '@/utils/mapRelationship'

export default {
  name: 'MealPlanProgress',
  props: {
    v2Cart: { type: Object, default: null },
    compact: { type: Boolean, default: false }
  },
  computed: {
    isV2() {
      return !!this.v2Cart
    },
    cart() {
      return this.$store.getters.currentCart
    },
    customer() {
      return this.$store.getters.customer
    },
    mealPlanSubscription() {
      return mapRelationship(this.$store.state, this.customer?.relationships?.meal_plan_subscription?.data)
    },
    included() {
      if (this.isV2) return this.v2Cart?.meal_plan?.included_count || 0
      return this.cart?.attributes?.meal_plan_included_count || 0
    },
    available() {
      if (this.isV2) {
        const includedCount = this.v2Cart?.meal_plan?.included_count || 0
        const balanceRemaining = this.v2Cart?.meal_plan?.balance_remaining_after_cart || 0
        return includedCount + balanceRemaining
      }
      const remainingMealCredits = this.mealPlanSubscription?.attributes?.remaining_meal_credits
      return remainingMealCredits == null ? null : remainingMealCredits
    },
    hasVisibleContent() {
      // Hide whenever there's no real allotment to show progress against - even
      // if `included` is stale/nonzero (e.g. credits were revoked after the
      // cart already burned some). Showing "N of 0 meals included" is worse
      // than showing nothing.
      return !!this.available
    },
    progressText() {
      return `${this.included} of ${this.available} meals included`
    },
    fillWidth() {
      const pct = this.available > 0 ? (this.included / this.available) * 100 : 0
      return `${Math.min(100, pct)}%`
    }
  }
}
</script>
